import { render, staticRenderFns } from "./InsuranceTable2Item.vue?vue&type=template&id=0958523f&scoped=true&"
import script from "./InsuranceTable2Item.vue?vue&type=script&lang=js&"
export * from "./InsuranceTable2Item.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceTable2Item.vue?vue&type=style&index=0&id=0958523f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0958523f",
  null
  
)

export default component.exports